module.exports = __webpack_public_path__ + "img/round-arrow-right-white.ffe89eec.svg";